export default __webpack_public_path__ + "static/media/icon-communities.e889ff65.svg";